export const linkTemplate = () => '';

export default linkTemplate;
